import * as React from "react";
import { RegisterController } from "@njoy/controller";
import { useNavigate } from "react-router-dom";
import { RegisterView } from "./ui/RegisterView";
import { MemberVerification } from "@njoy/common";
import { useTenantConfig } from "../../../hooks/useTenantConfig";

export const RegisterConnector: React.FC = () => {
  const navigate = useNavigate();
  const { config } = useTenantConfig();
  const requiresMemberId = config?.memberVerification === MemberVerification.Cbm;

  const onFinish = (email: string) => {
    localStorage.setItem("verifyEmail", email);
    navigate(`/verify/confirm-account?email=${encodeURIComponent(email)}`);
  };

  return (
    <RegisterController>
      {({ submit }) => (
        <RegisterView onFinish={onFinish} submit={submit} requiresMemberId={requiresMemberId} />
      )}
    </RegisterController>
  );
};